export interface EventItem {
  title: string;
  website: string;
  region: string[];
  category: string;
  imageUrl?: string;
}

export const EVENTS: EventItem[] = [
  {
    title: 'Hyde Park Winter Wonderland',
    website: 'https://hydeparkwinterwonderland.com/',
    region: ['EMEA'],
    category: 'Lifestyle',
    imageUrl: '/events/Hyde-Park-Winter-Wonderland.jpg',
  },
  {
    title: 'Miami Open presented by Itaú',
    website: 'https://www.miamiopen.com/',
    region: ['Americas'],
    category: 'Sports',
    imageUrl: '/events/Miami-Open.jpg',
  },
  {
    title: 'Mutua Madrid Open',
    website: 'https://mutuamadridopen.com/en/',
    region: ['EMEA'],
    category: 'Sports',
    imageUrl: '/events/Madrid-Open.jpg',
  },
  {
    title: 'Nike Melbourne Marathon',
    website: 'https://melbournemarathon.com.au/',
    region: ['APAC'],
    category: 'Sports',
    imageUrl: '/events/Melbourne-Marathon.jpg',
  },
  {
    title: 'TodayTix',
    website: 'https://www.todaytix.com/',
    region: ['Americas', 'EMEA', 'APAC'],
    category: 'Ticketing and Technology',
    imageUrl: '/events/TodayTix.jpg',
  },
  {
    title: 'Bucket Listers',
    website: 'https://bucketlisters.com/select-city',
    region: ['Americas'],
    category: 'Ticketing and Technology',
    imageUrl: '/events/Bucket-Listers.jpg',
  },
  {
    title: 'Frieze London',
    website: 'https://www.frieze.com/fairs/frieze-london',
    region: ['EMEA'],
    category: 'Arts',
    imageUrl: '/events/Frieze-London.jpg',
  },
  {
    title: 'Frieze Masters',
    website: 'https://www.frieze.com/fairs/frieze-masters',
    region: ['EMEA'],
    category: 'Arts',
    imageUrl: '/events/Frieze-Masters.jpg',
  },
  {
    title: 'Frieze Abu Dhabi',
    website:
      'https://www.frieze.com/article/announcing-launch-frieze-abu-dhabi',
    region: ['EMEA'],
    category: 'Arts',
    imageUrl: '/events/Frieze-Abu-Dhabi.jpg',
  },
  {
    title: 'Frieze Magazine',
    website: 'https://www.frieze.com/editorial/',
    region: ['Global'],
    category: 'Arts',
    imageUrl: '/events/Frieze-Magazine.jpg',
  },
  {
    title: 'Frieze No. 09 Cork Street',
    website: 'https://www.frieze.com/no9-cork-street',
    region: ['EMEA'],
    category: 'Arts',
    imageUrl: '/events/Frieze-No.-09-Cork-Street.jpg',
  },
  {
    title: 'Frieze House Seoul',
    website: 'https://www.frieze.com/frieze-house-seoul',
    region: ['APAC'],
    category: 'Arts',
    imageUrl: '/events/Frieze-House-Seoul.jpg',
  },
  {
    title: 'Barrett-Jackson Palm Beach',
    website: 'https://www.barrett-jackson.com/consignment',
    region: ['Americas'],
    category: 'Collectibles',
    imageUrl: '/events/Barrett-Jackson-Palm-Beach.jpg',
  },
  {
    title: 'Barrett-Jackson Scottsdale',
    website: 'https://www.barrett-jackson.com/consignment',
    region: ['Americas'],
    category: 'Collectibles',
    imageUrl: '/events/Barrett-Jackson-Scottsdale.jpg',
  },
  {
    title: 'Barrett-Jackson Columbus',
    website: 'https://www.barrett-jackson.com/consignment',
    region: ['Americas'],
    category: 'Collectibles',
    imageUrl: '/events/Barrett-Jackson-Columbus.jpg',
  },
  {
    title: 'Barrett-Jackson Las Vegas',
    website: 'https://www.barrett-jackson.com/consignment',
    region: ['Americas'],
    category: 'Collectibles',
    imageUrl: '/events/Barrett-Jackson-Las-Vegas.jpg',
  },
  {
    title: 'Hampton Court Palace Festival',
    website: 'https://hamptoncourtpalacefestival.com/',
    region: ['EMEA'],
    category: 'Lifestyle',
    imageUrl: '/events/Hampton-Court-Palace.jpg',
  },
  {
    title: 'Blenheim Palace Festival',
    website: 'https://www.blenheimpalacefestival.com/',
    region: ['EMEA'],
    category: 'Lifestyle',
    imageUrl: '/events/Blenheim-Palace-Festival.jpg',
  },
  {
    title: 'Taste of Paris',
    website: 'https://paris.tastefestivals.com/en/',
    region: ['EMEA'],
    category: 'Lifestyle',
    imageUrl: '/events/Taste-of-Paris.jpg',
  },
  {
    title: 'Taste of London',
    website: 'https://london.tastefestivals.com/',
    region: ['EMEA'],
    category: 'Lifestyle',
    imageUrl: '/events/Taste-of-London.jpg',
  },
  {
    title: 'Big Feastival',
    website: 'https://bigfeastival.com/',
    region: ['EMEA'],
    category: 'Lifestyle',
    imageUrl: '/events/Big-Feastival.jpg',
  },
  {
    title: 'Glide',
    website: 'https://glidebatterseapowerstation.co.uk/',
    region: ['EMEA'],
    category: 'Lifestyle',
    imageUrl: '/events/Glide.jpg',
  },
  {
    title: 'Battersea Lift',
    website: 'https://batterseapowerstation.co.uk/retailers/the-chimney-lift/',
    region: ['EMEA'],
    category: 'Lifestyle',
    imageUrl: '/events/Battersea-Lift.jpg',
  },
  {
    title: 'Great Ocean Road Running Festival',
    website: 'https://greatoceanroadrunfest.com.au/',
    region: ['APAC'],
    category: 'Sports',
    imageUrl: '/events/Great-Ocean-Road.jpg',
  },
  {
    title: 'Escape from Alcatraz',
    website: 'https://www.escapealcatraztri.com/',
    region: ['Americas'],
    category: 'Sports',
    imageUrl: '/events/Escape-from-Alcatraz.jpg',
  },
  {
    title: 'Harry Potter: A Forbidden Experience',
    website: 'https://hpforbiddenforestexperience.com/',
    region: ['Americas', 'APAC'],
    category: 'Lifestyle',
    imageUrl: '/events/Harry-Potter-A-Forbidden-Forest-Experience.jpg',
  },
  {
    title: 'EXPO Chicago',
    website: 'https://www.expochicago.com/',
    region: ['Americas'],
    category: 'Arts',
    imageUrl: '/events/EXPO-Chicago.jpg',
  },
  {
    title: ' Mubadala Abu Dhabi Open',
    website: 'https://www.mubadalaabudhabiopen.com/',
    region: ['EMEA'],
    category: 'Sports',
    imageUrl: '/events/Abu-Dhabi-Open.jpg',
  },
  {
    title: 'Rio Open',
    website: 'https://www.rioopen.com/en',
    region: ['Americas'],
    category: 'Sports',
    imageUrl: '/events/Rio-Open.jpg',
  },
  {
    title: 'Giorgio Armani Tennis Classic',
    website: 'https://www.giorgioarmanitennisclassic.com/the-tennis',
    region: ['EMEA'],
    category: 'Sports',
    imageUrl: '/events/Hurlingham-Tennis.jpg',
  },
  {
    title: 'Mubadala Citi DC Open',
    website: 'https://www.mubadalacitidcopen.com/en',
    region: ['Americas'],
    category: 'Sports',
    imageUrl: '/events/DC-Open.jpg',
  },
  {
    title: 'US Open of Surfing',
    website: 'https://www.usopenofsurfing.com/',
    region: ['Americas'],
    category: 'Sports',
    imageUrl: '/events/Beach-Games,-US-Open.jpg',
  },
  {
    title: 'São Paulo Open',
    website: 'https://www.wtatennis.com/tournaments/1139/sao-paulo/2025',
    region: ['Americas'],
    category: 'Sports',
    imageUrl: '/events/Sao-Paolo-Open.jpg',
  },
  {
    title: 'Kinoshita Group Japan Open',
    website: 'https://www.wtatennis.com/tournaments/405/osaka/2025',
    region: ['APAC'],
    category: 'Sports',
    imageUrl: '/events/Japan-Open.jpg',
  },
  {
    title: 'MGM Macau Tennis Masters',
    website: 'https://www.mgmmacautennis.com/2024/en/',
    region: ['APAC'],
    category: 'Sports',
    imageUrl: '/events/Macau-Masters.jpg',
  },
  {
    title: 'Chengdu Open',
    website: 'https://www.atptour.com/en/tournaments/chengdu/7581/overview',
    region: ['APAC'],
    category: 'Sports',
    imageUrl: '/events/Chengdu-Open.jpg',
  },
  {
    title: 'Bank of China Hong Kong Tennis Open',
    website: 'https://www.hkmenstennisopen.com/en_us',
    region: ['APAC'],
    category: 'Sports',
    imageUrl: '/events/Prudential-Hong-Kong-Open.jpg',
  },
  {
    title: 'Frieze New York',
    website: 'https://www.frieze.com/fairs/frieze-new-york',
    region: ['Americas'],
    category: 'Arts',
    imageUrl: '/events/Frieze-NY.jpg',
  },
  {
    title: 'Frieze Los Angeles',
    website: 'https://www.frieze.com/fairs/frieze-los-angeles',
    region: ['Americas'],
    category: 'Arts',
    imageUrl: '/events/Frieze-LA.jpg',
  },
  {
    title: 'Frieze Seoul',
    website: 'https://www.frieze.com/fairs/frieze-seoul',
    region: ['APAC'],
    category: 'Arts',
    imageUrl: '/events/Frieze-Seoul.jpg',
  },
  {
    title: 'The Armory Show',
    website: 'https://www.thearmoryshow.com/',
    region: ['Americas'],
    category: 'Arts',
    imageUrl: '/events/The-Armory-Show.jpg',
  },
  {
    title: 'Secret Cinema',
    website: 'https://www.secretcinema.com/',
    region: ['EMEA', 'Americas'],
    category: 'Lifestyle',
    imageUrl: '/events/Secret-Cinema.jpg',
  },
  {
    title: 'Studio Secret Cinema',
    website: 'https://studiosecretcinema.com/',
    region: ['EMEA', 'Americas'],
    category: 'Lifestyle',
    imageUrl: '/events/Studio-Secret-Cinema.jpg',
  },
  {
    title: 'Melbourne International Flower & Garden Show',
    website: 'https://melbflowershow.com.au/',
    region: ['APAC'],
    category: 'Lifestyle',
    imageUrl: '/events/Melbourne-International-Flower-&-Garden-Show.jpg',
  },
  {
    title: 'Collect-A-Con',
    website: 'https://collectaconusa.com/',
    region: ['Americas'],
    category: 'Collectibles',
    imageUrl: '/events/Collect-A-Con.jpg',
  },
  {
    title: 'Bondi to Manly Ultra',
    website: 'https://www.bonditomanlyultra.com/',
    region: ['APAC'],
    category: 'Sports',
    imageUrl: '/events/Bondi-to-Manly-Ultra-Marathon.jpg',
  },
  {
    title: 'From the Heart to the Hands: Dolce&Gabbana',
    website: '',
    region: ['Americas'],
    category: 'Arts',
    imageUrl: '/events/Dolce-&-Gabbana-Miami.jpg',
  },
];

export function getAllCategories(): string[] {
  // return Array.from(new Set(EVENTS.map((event) => event.category)));
  return [
    'Lifestyle',
    'Sports',
    'Arts',
    'Collectibles',
    'Ticketing and Technology',
  ];
}

export function getAllRegions(): string[] {
  return Array.from(
    new Set(
      EVENTS.flatMap((event) =>
        event.region.flatMap((r) => r.split(',').map((t) => t.trim())),
      ),
    ),
  ).sort((a, b) => {
    const aLower = a.toLowerCase();
    const bLower = b.toLowerCase();
    return aLower.localeCompare(bLower);
  });
}
